import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Wraps https://github.com/littlebits/react-popover
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPopover from 'react-popover';
import { connect } from 'react-redux';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
var Popover = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Popover, _Component);

  var _super = _createSuper(Popover);

  function Popover() {
    _classCallCheck(this, Popover);

    return _super.apply(this, arguments);
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var body = /*#__PURE__*/React.createElement(MuiThemeProvider, {
        muiTheme: getTheme(this.props.theme)
      }, this.props.content);
      return /*#__PURE__*/React.createElement(ReactPopover, {
        preferPlace: this.props.preferPlace,
        isOpen: this.props.open,
        body: body
      }, this.props.children);
    }
  }]);

  return Popover;
}(Component), _defineProperty(_class2, "propTypes", {
  preferPlace: PropTypes.string,
  open: PropTypes.bool,
  children: PropTypes.node,
  content: PropTypes.node
}), _defineProperty(_class2, "defaultProps", {
  preferPlace: 'left',
  open: false
}), _temp)) || _class);
export { Popover as default };